export default "__VITE_ASSET__CQcpN8GO__"